const renderDateMessage = (path: string, t: any) => {
	return `${t(path.replace(/\[\d+\][.]/, "-").replace(".", "-"))} ${t("valid-date-message")}`;
};

export default renderDateMessage;
